import {
  ColumnLayout,
  Box,
  Button,
} from "@cloudscape-design/components-themed";
import { useLocation, useNavigate } from "react-router-dom";
import { COMMON_LABELS, stringToBoolean } from "../default-constants";
import { useAppDispatch } from "../../app/hook";
import { usePutIndividualHandlingConfirmationTargetUpdateMutation } from "../../features/api";
import { useCallback } from "react";
import {
  ConfirmationUpdateStoreInfo,
  ConfirmationUpdateMerchantInfo,
  IndividualHandlingConfirmationUpdateRequest,
  ConfirmationMerchantInfo,
  ConfirmationStoreInfo,
} from "../../features/api-interfaces";
import { showModal } from "../UI/modal/modal-slice";
import { differenceWith, isEqual, pick } from "lodash";

interface IFooter {
  applicationNo: string;
  isMerchantRegistered: boolean;
  merchant: ConfirmationMerchantInfo | undefined;
  registeredStoreList: ConfirmationStoreInfo[];
  storeList: ConfirmationStoreInfo[] | undefined;
  disabledUpdateButton: boolean;
  refetch: Function;
}

/**
 * フッターのボタン群
 */
const Footer = (props: IFooter) => {
  const {
    applicationNo,
    isMerchantRegistered,
    merchant,
    registeredStoreList,
    storeList,
    disabledUpdateButton,
    refetch,
  } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const isBackToList = stringToBoolean(query.get("isBackToList"));
  const [putIndividualHandlingConfirmationTargetUpdate] =
    usePutIndividualHandlingConfirmationTargetUpdateMutation();

  /**
   * 戻るボタンを押したときの処理.
   */
  const backOnClick = () => {
    if (!isBackToList) {
      navigate(`/application-status/${applicationNo}`);
    } else {
      navigate(`/individual-handling-confirmation?isBackFromDetail=true`);
    }
  };

  /**
   * 更新ボタンを押下したときの処理.
   */
  const updateOnClick = useCallback(() => {
    dispatch(
      showModal({
        content: COMMON_LABELS.CONTENTS.UPDATE_CONFIRM,
        positiveFn: () => {
          const updateStoreItems = differenceWith(
            storeList,
            registeredStoreList,
            isEqual
          ).map(
            (store) =>
              ({
                applicationStatusNo: store.applicationStatusNo,
                individualHandlingReason: store.individualHandlingReason,
                confirmationResult: store.confirmationResult,
                comment: store.comment,
              } as ConfirmationUpdateStoreInfo)
          );

          const updateMerchant = isMerchantRegistered
            ? undefined
            : (pick(merchant, [
                "applicationStatusNo",
                "confirmationResult",
                "comment",
                "rateCategoryCode",
                "individualConsultationNo",
                "individualConsultationBranchNo",
              ]) as ConfirmationUpdateMerchantInfo);
          const request: IndividualHandlingConfirmationUpdateRequest = {
            merchant: updateMerchant,
            storeInfoList: updateStoreItems ?? undefined,
          };
          putIndividualHandlingConfirmationTargetUpdate(request).then(
            (result: any) => {
              if (
                !("error" in result) &&
                !result.data.status.includes("error")
              ) {
                if (!isBackToList) {
                  navigate(`/application-status/${applicationNo}`);
                } else {
                  refetch();
                }
              }
            }
          );
        },
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    storeList,
    registeredStoreList,
    isMerchantRegistered,
    merchant,
    isBackToList,
    applicationNo,
  ]);

  return (
    <ColumnLayout columns={2}>
      <Box float={"left"}>
        <Button formAction={"none"} variant={"link"} onClick={backOnClick}>
          {COMMON_LABELS.BTNS.BACK}
        </Button>
      </Box>

      <Box float={"right"}>
        <Button
          variant={"primary"}
          onClick={updateOnClick}
          disabled={disabledUpdateButton}
        >
          {COMMON_LABELS.BTNS.UPDATE}
        </Button>
      </Box>
    </ColumnLayout>
  );
};

export default Footer;
